import React, { Component } from 'react';
import CapacitorRipple from '../capacitor/Ripple';
import styles from './BrowseElement.css';
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import ArtistAvatar from '../common/ArtistAvatar';
import CollectionButton from '../common/CollectionButton';
import collectibleEntity, { collectibleEntityPropTypes } from '../../hoc/collectibleEntity';
import { ENTITY_TYPE_ARTIST } from '../../constants';
import { compose } from 'redux';

class BrowseElement extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    href: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    showCollectionButton: PropTypes.bool,
    ...collectibleEntityPropTypes,
  };

  render() {
    const { id, name, href, isInCollection, toggleIsInCollection, showCollectionButton } =
      this.props;
    return (
      <div key={id} className={styles.el} data-test="browse-element">
        <ArtistAvatar profileId={id} className={styles.img} />
        <span className={styles.text}>{name}</span>
        {showCollectionButton && (
          <CollectionButton
            active={isInCollection}
            onClick={toggleIsInCollection}
            className={styles.collectionButton}
          />
        )}
        <Link
          to={href}
          className="c-link--expand-hitbox"
          onClick={this.onItemClick}
          data-test="browse-element.link"
          aria-label={name}
        >
          <CapacitorRipple />
        </Link>
      </div>
    );
  }
}

function getCollectibleEntityDescription(props) {
  return {
    id: props.id,
    trackingSource: 'Profile',
  };
}

export default compose(collectibleEntity(ENTITY_TYPE_ARTIST, getCollectibleEntityDescription))(
  BrowseElement
);
